export const buildAccountId = ({ appDefId, appInstanceId }: { appDefId: string; appInstanceId: string }): string =>
  `${appDefId}:${appInstanceId}`;
